var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShowInsta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 104,
    viewBox: "0 0 87 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8103_782)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.673 7.92302C68.3634 5.50157 64.2331 4.48174 60.1768 5.08451L13.3195 11.8467C11.2827 12.1492 9.44836 13.2454 8.21716 14.896C6.98595 16.5465 6.45789 18.6171 6.74832 20.6557C6.89229 21.6745 7.23657 22.6547 7.76128 23.5398C8.286 24.4249 8.98077 25.1973 9.80551 25.8125C10.6303 26.4278 11.5687 26.8736 12.5666 27.1243C13.5645 27.3751 14.6022 27.4257 15.6198 27.2734L51.4443 22.0052L4.84042 84.4803C3.60441 86.1372 3.07724 88.2173 3.37488 90.2629C3.67253 92.3085 4.7706 94.1522 6.42754 95.3882C8.08449 96.6242 10.1646 97.1513 12.2102 96.8537C14.2558 96.5561 16.0994 95.458 17.3354 93.801L63.9393 31.3259L69.161 67.2129C69.4515 69.2607 70.5437 71.1092 72.1972 72.3518C73.8507 73.5944 75.9301 74.1292 77.9779 73.8386C80.0257 73.548 81.8742 72.4559 83.1168 70.8024C84.3593 69.1489 84.8941 67.0695 84.6036 65.0217L77.7323 18.1802C77.1502 14.0937 74.9711 10.405 71.673 7.92302Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8103_782"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 87,
    height: 104,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowInsta);
export default __webpack_public_path__ + "static/media/show-insta.9699ab0053ceec1320eb5c35cbca1b00.svg";
export { ForwardRef as ReactComponent };